import { SalesNavigationProps } from './types.ts'
import useWindowSize from 'hooks/useWindowSize.tsx'
import { SMALL_DESKTOP_BREAKPOINT } from 'constants/viewport.ts'
import DesktopSalesNavigation from './desktop-navigation/DesktopSalesNavigation.tsx'
import BottomSalesNavigation from './mobile-navigation/BottomSalesNavigation.tsx'

const SalesNavigation = (props: SalesNavigationProps) => {
  // Window size
  const { isSmaller } = useWindowSize(SMALL_DESKTOP_BREAKPOINT)

  return isSmaller ? <BottomSalesNavigation {...props} /> : <DesktopSalesNavigation {...props} />
}

export default SalesNavigation
